import Ip from 'api/models/Engines/Ip';

const dataToCopyTextMapper = (data: Ip) => {
	return data;
};

export default dataToCopyTextMapper;
